/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type NalEvaluationMilestoneValue = {
    readonly milestone: NalEvaluationMilestoneValue.milestone;
    readonly nal: number | null;
    readonly nzla: number | null;
    readonly recorded_at: string;
    readonly recorded_by_name: string | null;
    readonly recorded_by_me: boolean;
};
export namespace NalEvaluationMilestoneValue {
    export enum milestone {
        CSM_CLOSING = 'csm_closing',
        MANAGER_RELEASE = 'manager_release',
        CONTROLLING_RELEASE = 'controlling_release',
    }
}

